import { useUnit } from 'effector-react';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { $menuState, setActiveItemIdEvent } from '@nx-frontend/shared/store/feature-menu-tree';
import { $notes } from '@nx-frontend/shared/store/notes';
import { setPortalExpandedItemsInListEvent, $portalSettings } from '@nx-frontend/shared/store/portal';
import { MenuItemType, MenuType } from '@nx-frontend/shared/types';
import { scrollToSidebarMenuItem } from '@nx-frontend/shared/utils';

// TODO temporary interface duplicate
// need to move ExpandAllParentFoldersEventParams to shared/types
export interface ExpandAllParentFoldersEventParams {
  menuType: MenuType;
  /**
   * Currently selected item id, for example notesFolder#default
   */
  id: string;
  /**
   * ParentId of selected item, whose items need to be fetched
   */
  parentId: string | undefined;
  parentIds?: string[] | undefined;
  workspaceId?: string;
  /**
   * Do not scroll to item identified by id
   */
  doNotScrollToNote?: boolean;
}

interface UseSelectMenuItemParams {
  expandAllPortalParentFolders?: (params: ExpandAllParentFoldersEventParams) => void;
}

export function useSelectMenuItem({ expandAllPortalParentFolders }: UseSelectMenuItemParams) {
  const [notes, currentWorkspace, menuState, portalSettings] = useUnit([
    $notes,
    $currentWorkspace,
    $menuState,
    $portalSettings,
  ]);
  const [setPortalExpandedItemsInList, setActiveItemId] = useUnit([
    setPortalExpandedItemsInListEvent,
    setActiveItemIdEvent,
  ]);

  return (itemId: string) => {
    const currentStoreNote = notes.workspaces[currentWorkspace.globalId]?.entities[itemId];
    if (currentStoreNote) {
      const id = `${currentStoreNote.type === 'note' ? MenuItemType.NOTE : MenuItemType.NOTES_FOLDER}#${itemId}`;
      scrollToSidebarMenuItem(id);
    } else {
      [MenuType.PORTAL_SIDEBAR, MenuType.PORTAL_TOPBAR, MenuType.PORTAL_FOOTER].forEach((menuType) => {
        const item = Object.values(menuState[menuType].entities).find(({ targetId }) => targetId === itemId);
        if (item) {
          setPortalExpandedItemsInList({
            portalId: portalSettings.id,
            itemIds: ['portal', 'contentAndLinks', menuType],
          });
          if (expandAllPortalParentFolders) {
            expandAllPortalParentFolders({
              menuType,
              id: item.id,
              parentId: item.parentId,
            });
          }
          setActiveItemId({
            menuType,
            id: item.id,
          });
          setActiveItemId({ menuType: MenuType.WEBNOTES_MENU, id: null });
          setTimeout(() => {
            scrollToSidebarMenuItem(item.id);
          }, 0);
        }
      });
    }
  };
}
